// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"251":"f2df019c","717":"be78b751"}[chunkId] + ".chunk.css";
};